<app-signup-component [keyParam]="this.keyParam"></app-signup-component>
